import * as React from 'react';
// import { Link } from 'react-router-dom';
// import { Carlton } from '../carlton/carlton.component';
import { history } from 'src';
import { Emoji } from '@common/components/emoji/Emoji';

export const NotFoundComponent = () => (
  <div className="row middle-xs center-xs" style={{ minHeight: '60vh' }}>
    <h2>
      <strong>404!</strong> Uh oh, we're not sure what you're looking for so here's a random emoji!
    </h2>
    <div className="col-xs-12 mt-10 pt-10 mb-10 pb-10">
      <Emoji size={window.innerWidth / 4 > 200 ? 200 : window.innerWidth / 4} />
    </div>
    <div className="col-xs-12 mt-10 pt-10">
      <button className="btn btn-secondary" onClick={() => window.history.back()}>
        Go Back
      </button>
      <button onClick={() => history.push('/dashboard')} className="btn btn-primary">
        Go to the Dashboard
      </button>
    </div>
    {/* <div className="col-xs-12">
      <h3 className="mb-10">(Be sure to turn your volume up)</h3>
    </div>
    <Carlton /> */}
  </div>
);



// WEBPACK FOOTER //
// ./src/common/components/not-found/not-found.component.tsx